"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataApi_1 = require("../DataApi");

var DataModelApi_1 = require("../DataModelApi");

var HealthcheckApi_1 = require("../HealthcheckApi");

var PeekdataApi =
/** @class */
function () {
  function PeekdataApi(options) {
    this.data = new DataApi_1.DataApi(options);
    this.datamodel = new DataModelApi_1.DataModelApi(options);
    this.health = new HealthcheckApi_1.HealthcheckApi(options);
  }

  return PeekdataApi;
}();

exports.PeekdataApi = PeekdataApi;